import { render, staticRenderFns } from "./DefaultPreview.svg.vue?vue&type=template&id=2418fe60"
import script from "./DefaultPreview.svg.vue?vue&type=script&lang=ts"
export * from "./DefaultPreview.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2418fe60')) {
      api.createRecord('2418fe60', component.options)
    } else {
      api.reload('2418fe60', component.options)
    }
    module.hot.accept("./DefaultPreview.svg.vue?vue&type=template&id=2418fe60", function () {
      api.rerender('2418fe60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/DefaultPreview.svg.vue"
export default component.exports